/* Novaris v38 — stationary, translucent counter for the MOBILE product gallery.
 * Reads the original Liquid image indices; never changes the gallery, variants,
 * cart, dots, image order or Flickity options. No dependency on an app's API.
 */
(function () {
  'use strict';
  if (window.NovarisMobileProductCounter) return;

  var mq = window.matchMedia('(max-width: 768px)');
  var gallerySelector = '.template-product .product-section[data-history="true"] .product__main-photos';
  var sourceSelector = '.nv-mobile-product-image-counter';
  var readyClass = 'nv-mobile-product-gallery--counter-ready';
  var states = [];

  function unbindFlickity(state) {
    if (!state.flickity) return;
    state.flickity.off('select', state.update);
    state.flickity.off('cellChange', state.schedule);
    state.flickity.off('destroy', state.schedule);
    state.flickity = null;
  }

  function bindFlickity(state, slider) {
    var instance = window.Flickity && typeof window.Flickity.data === 'function'
      ? window.Flickity.data(slider) : null;
    if (instance === state.flickity) return;
    unbindFlickity(state);
    if (!instance) return;
    state.flickity = instance;
    instance.on('select', state.update);
    instance.on('cellChange', state.schedule);
    instance.on('destroy', state.schedule);
  }

  function createCounter(gallery) {
    if (states.some(function (state) { return state.gallery === gallery; })) return;
    var slider = gallery.querySelector('[data-product-photos]');
    if (!slider || !slider.querySelector(sourceSelector)) return;

    var counter = document.createElement('span');
    counter.className = 'nv-mobile-product-image-counter nv-mobile-product-image-counter--fixed';
    counter.setAttribute('role', 'status');
    counter.setAttribute('aria-live', 'polite');
    counter.setAttribute('aria-atomic', 'true');
    counter.hidden = true;

    var state = { gallery: gallery, counter: counter, flickity: null, frame: 0, disposed: false };

    state.update = function () {
      if (state.disposed || !mq.matches || !gallery.isConnected) return;
      var currentSlider = gallery.querySelector('[data-product-photos]');
      if (!currentSlider) {
        unbindFlickity(state);
        counter.hidden = true;
        return;
      }
      bindFlickity(state, currentSlider);

      // Flickity keeps selectedElement in sync for swipes, arrows and variants.
      // The DOM fallback also handles one image and delayed/rebuilt galleries.
      var slide = state.flickity && state.flickity.selectedElement;
      if (!slide || !currentSlider.contains(slide)) {
        slide = currentSlider.querySelector('.product-main-slide.is-selected');
      }
      if (!slide && !currentSlider.classList.contains('flickity-enabled')) {
        slide = currentSlider.querySelector('.product-main-slide.starting-slide') ||
          currentSlider.querySelector('.product-main-slide');
      }
      var source = slide && slide.querySelector(sourceSelector);
      var text = source ? source.textContent.trim().replace(/\s+/g, ' ') : '';
      var parts = text.match(/^(\d+)\s*\/\s*(\d+)$/);

      // Video/model slides did not have an image counter in v37; keep that behavior.
      if (!parts) {
        counter.hidden = true;
        return;
      }
      // Reserve width from the TOTAL, so 9 / 12 -> 10 / 12 never moves the badge.
      var textWidth = (parts[2].length * 2 + 3) + 'ch';
      if (counter.style.getPropertyValue('--nv-mobile-counter-text-width') !== textWidth) {
        counter.style.setProperty('--nv-mobile-counter-text-width', textWidth);
      }
      text = parts[1] + ' / ' + parts[2];
      var label = 'Imagen ' + parts[1] + ' de ' + parts[2];
      if (counter.textContent !== text) counter.textContent = text;
      if (counter.getAttribute('aria-label') !== label) counter.setAttribute('aria-label', label);
      counter.hidden = false;
      // A sibling of the slideshow, NEVER a child of its transformed track.
      if (counter.parentNode !== gallery) gallery.appendChild(counter);
    };

    state.schedule = function () {
      if (state.disposed || state.frame) return;
      state.frame = window.requestAnimationFrame(function () {
        state.frame = 0;
        state.update();
      });
    };

    // Observe structural/selected-class changes only, NOT per-frame transforms.
    // Ignore our own badge updates so the observer cannot feed back on itself.
    state.observer = new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        return record.target !== counter && !counter.contains(record.target) &&
          !(record.target === gallery && record.type === 'attributes');
      });
      if (relevant) state.schedule();
    });

    gallery.appendChild(counter);
    gallery.classList.add(readyClass);
    state.observer.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    states.push(state);
    state.update();
  }

  function dispose(state) {
    state.disposed = true;
    state.observer.disconnect();
    unbindFlickity(state);
    if (state.frame) window.cancelAnimationFrame(state.frame);
    state.counter.remove();
    state.gallery.classList.remove(readyClass);
  }

  function init(root) {
    states = states.filter(function (state) {
      if (!mq.matches || !state.gallery.isConnected) {
        dispose(state);
        return false;
      }
      return true;
    });
    if (!mq.matches || !document.body || !document.body.classList.contains('template-product')) return;
    root = root || document;
    if (root.matches && root.matches(gallerySelector)) createCounter(root);
    root.querySelectorAll(gallerySelector).forEach(createCounter);
    states.forEach(function (state) { state.schedule(); });
  }

  function onViewportChange() { init(document); }
  if (mq.addEventListener) mq.addEventListener('change', onViewportChange);
  else mq.addListener(onViewportChange);

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    states = states.filter(function (state) {
      if (event.target === state.gallery || event.target.contains(state.gallery)) {
        dispose(state);
        return false;
      }
      return true;
    });
  });
  window.addEventListener('pageshow', function () { init(document); });
  window.addEventListener('load', function () { init(document); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  window.NovarisMobileProductCounter = { version: '1.0.0' };
})();
